import { makeAutoObservable, runInAction } from 'mobx';
import { ShopDashboardData } from 'src/@types/Choqorak/Dashboards/Dashboard';
import agent from 'src/api/agent';
export default class Dashboardstore {
  DashboardData: ShopDashboardData | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  //Pagination
  loadDashboard = async () => {
    try {
      const result = await agent.Dashboard.getDashboard();
      runInAction(() => {
        this.DashboardData = result.data;
      });
    } catch (error) {
      console.log(error);
    }
  };
}
